import { render, staticRenderFns } from "./enterInfo.vue?vue&type=template&id=38cc14c4&scoped=true"
import script from "./enterInfo.vue?vue&type=script&lang=js"
export * from "./enterInfo.vue?vue&type=script&lang=js"
import style0 from "./enterInfo.vue?vue&type=style&index=0&id=38cc14c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cc14c4",
  null
  
)

export default component.exports